module.exports = __webpack_public_path__ + "static/media/bulk2.3602f747.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/bulk2.png
// module id = 1627
// module chunks = 0